const checkCorrectSession = function (userData) {
  if (!userData || parseInt(userData.role) !== 1) {
    return false
  }
  return true
}
export default {
  checkCorrectSession
}



// WEBPACK FOOTER //
// ./src/store/modules/authComponents/checker.js